import React from 'react';
import { useTranslation } from 'react-i18next';

function SystemUserFormModal({
  title,
  isSaving,
  form,
  formErrors,
  showDisabled,
  onFormChange,
  onSubmit,
  onClose,
  submitLabel,
  includeConfirmPassword,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <form onSubmit={onSubmit}>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">{t('systemUsers.firstNameLabel')}</label>
                  <input
                    className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`}
                    value={form.firstName}
                    onChange={(event) => onFormChange('firstName', event.target.value)}
                    required
                  />
                  {formErrors.firstName ? <div className="invalid-feedback">{formErrors.firstName}</div> : null}
                </div>
                <div className="mb-3">
                  <label className="form-label">{t('systemUsers.lastNameLabel')}</label>
                  <input
                    className={`form-control ${formErrors.lastName ? 'is-invalid' : ''}`}
                    value={form.lastName}
                    onChange={(event) => onFormChange('lastName', event.target.value)}
                    required
                  />
                  {formErrors.lastName ? <div className="invalid-feedback">{formErrors.lastName}</div> : null}
                </div>
                <div className="mb-3">
                  <label className="form-label">{t('systemUsers.usernameLabel')}</label>
                  <input
                    className={`form-control ${formErrors.email ? 'is-invalid' : ''}`}
                    value={form.email}
                    onChange={(event) => onFormChange('email', event.target.value)}
                    required
                  />
                  {formErrors.email ? <div className="invalid-feedback">{formErrors.email}</div> : null}
                </div>
                {showDisabled ? (
                  <div className="mb-3">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="edit-user-disabled"
                        checked={Boolean(form.disabled)}
                        onChange={(event) => onFormChange('disabled', event.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="edit-user-disabled">{t('systemUsers.disabledLabel')}</label>
                      {formErrors.disabled ? <div className="text-danger small mt-1">{formErrors.disabled}</div> : null}
                    </div>
                  </div>
                ) : null}
                <div className="mb-3">
                  <label className="form-label">
                    {includeConfirmPassword ? t('systemUsers.passwordRequired') : t('systemUsers.passwordLabel')}
                  </label>
                  <input
                    type="password"
                    className={`form-control ${formErrors.password ? 'is-invalid' : ''}`}
                    value={form.password}
                    onChange={(event) => onFormChange('password', event.target.value)}
                    placeholder={includeConfirmPassword ? '' : t('systemUsers.passwordPlaceholder')}
                    required={includeConfirmPassword}
                  />
                  {formErrors.password ? <div className="invalid-feedback">{formErrors.password}</div> : null}
                </div>
                {includeConfirmPassword ? (
                  <div>
                    <label className="form-label">{t('systemUsers.confirmPasswordLabel')}</label>
                    <input
                      type="password"
                      className={`form-control ${formErrors.confirmPassword ? 'is-invalid' : ''}`}
                      value={form.confirmPassword}
                      onChange={(event) => onFormChange('confirmPassword', event.target.value)}
                      required
                    />
                    {formErrors.confirmPassword ? <div className="invalid-feedback">{formErrors.confirmPassword}</div> : null}
                  </div>
                ) : null}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={onClose} disabled={isSaving}>{t('common.cancel')}</button>
                <button type="submit" className="btn btn-theme" disabled={isSaving}>{submitLabel}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default SystemUserFormModal;
